<button class="btn btn-ghost" (click)="shareLink()">
  <fa-icon class="mr-xs" [icon]="shareIcon"></fa-icon>
  {{ buttonText }}
</button>
